<app-loading-indicator></app-loading-indicator>